<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="generic-no-results-message-box" :class="{ absolute }">
    {{ $t('message') }} <span class="highlight">{{ search }}</span>
  </div>
</template>

<script>
export default {
  name: 'EcsGenericNoResultsMessageBox',

  props: {
    search: {
      type: String,
      default: ''
    },
    absolute: {
      type: Boolean,
      default: false
    }
  },

  methods: {}
};
</script>

<style scoped>
.generic-no-results-message-box {
  background-color: #0001;
  padding: 20px;
  margin: 20px;
  border-radius: 8px;
  text-align: center;
  max-width: calc(100% - 40px);
}

.generic-no-results-message-box.absolute {
  top: 0;
  left: 0;
  right: 0;
  margin: 20px auto;
  position: absolute;
}

.generic-no-results-message-box .highlight {
  color: var(--v-primary-base);
}
</style>
